import * as React from 'react';

import { FDealType } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { useDealType } from '../../../utils/useDealType';
import { DealType } from '../../../components/filters/DealType';

export const DealTypeContainer: React.FC = () => {
  const { onChange, onApply } = useContext();
  const dealType = useDealType();

  const handleChange = React.useCallback(
    (dealType: FDealType) => {
      onChange({ action: 'setDealType', arguments: [dealType] });
      onApply();
    },
    [onChange, onApply],
  );

  return <DealType value={dealType} onChange={handleChange} />;
};
